const ButtonBox = ({
  children,
  borderColor = '#D97706',
  backgroundColor = '#FCD34D',
  borderRadius = '12px',
  borderWidth = '1px',
  className = '',
  onClick
}) => {
  return (
    <div
      className={`inline-block text-[14px] leading-[18px] sm:text-[16px] sm:leading-[24px] font-semibold ${className}`}
      style={{
        backgroundColor,
        borderColor,
        borderWidth,
        borderRadius,
        borderStyle: 'solid',
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default ButtonBox;
